import { routerGuard, routes } from '@/router';
import { createRouter, createWebHistory } from 'vue-router';

export const createRouterInstance = () => {
  const router = createRouter({
    history: createWebHistory(),
    routes,
  });
  router.beforeEach(routerGuard);
  return router;
};
